import '../../styles/particles.css';

import { useCallback } from "react";
import type { Container, Engine } from "tsparticles-engine";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { darkParticleOptions, lightParticleOptions } from './particleOptions';

const MainMenuBackgroundParticles = ({ theme }) => {
    const particleOptions = theme === 'dark' ? darkParticleOptions : lightParticleOptions;

    const particlesInit = useCallback(async (engine: Engine) => {
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container: Container | undefined) => {
    }, []);

    return (
        <div className="particles">
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={particleOptions}
            />
        </div>
    );
};

export default MainMenuBackgroundParticles;